// extracted by mini-css-extract-plugin
module.exports = {"container":"matchTime__container___1ZqeI","part":"matchTime__part___3RWpM","time":"matchTime__time___2iH99"};